import GrowthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';
import useOnboardingEligibility from 'bundles/onboarding-common/hooks/useOnboardingEligibility';

const useOnboardingV3 = () => {
  const { isEligibleForOnboardingV3, loading, hasSeenOnboarding, shouldRetriggerPathwaysOnboarding } =
    useOnboardingEligibility();

  const getShouldShowOnboardingV3 = () => {
    return isEligibleForOnboardingV3 && GrowthAcquisitionExperiments.preview('onboardingV3') !== 'control';
  };

  const getOnboardingV3Variant = () => {
    return isEligibleForOnboardingV3 ? GrowthAcquisitionExperiments.preview('onboardingV3') : 'control';
  };

  const getShouldShowOnboardingV3Variant1 = () => {
    return isEligibleForOnboardingV3 && GrowthAcquisitionExperiments.preview('onboardingV3') === 'variant1';
  };

  const getShouldShowOnboardingV3Variant2 = () => {
    return isEligibleForOnboardingV3 && GrowthAcquisitionExperiments.preview('onboardingV3') === 'variant2';
  };

  const impressIntoOnboardingV3WithEligibilityCheck = () => {
    // For the onboarding V3 experiment, we trigger an impression for:
    // - Newly registered visitors landing on the LIHP for the first time,
    // - Users who haven't seen onboarding before, or
    // - Users included in the pathways retrigger epics.
    const shouldGenerateImpression = !loading && (hasSeenOnboarding === false || shouldRetriggerPathwaysOnboarding);

    if (shouldGenerateImpression) {
      GrowthAcquisitionExperiments.get('onboardingV3');
    }
  };

  return {
    isEligibleForOnboardingV3,
    getShouldShowOnboardingV3,
    getShouldShowOnboardingV3Variant1,
    getShouldShowOnboardingV3Variant2,
    getOnboardingV3Variant,
    impressIntoOnboardingV3WithEligibilityCheck,
    loading,
  };
};

export default useOnboardingV3;
